export enum UnitOfMeasurementSourceTypeEnum {
  SYSTEM = "SYSTEM",
  CUSTOM = "CUSTOM",
}
